import { Injectable } from '@angular/core';
import { Room } from '../../../model/api/administration/room';
import { GenericHttpService } from '../generic.http.service';
import { AppConfig } from '../../../config'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Param } from '../../../model/common/param';
import { map } from 'rxjs/operators';
// import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class RoomHttpService extends GenericHttpService<Room, number> {
    constructor(public http: HttpClient) {
        super(http, "", "rooms");
    }

    public export(params: Array<Param>) {
        let searchParams: HttpParams = null;
        const url = AppConfig.urlPrefix + this.url + '/export';

        searchParams = this.getSearchParams(params);
        // return this.http.get(url, { responseType: ResponseContentType.Blob, params: searchParams })
        //                 .map(res => res.blob());

      return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob'}).pipe(
        map((result) => {
            return result;
        })
    );
    }
}